<template>
    <div class="container-fluid">
        <nav-header :navItems="[
            {
                name: 'Ask a question',
                link: {
                    name: 'Talk To My Data Streaming'
                }
            },
            {
                name: 'History',
                link: {
                    name: 'Talk To My Data Invocations'
                }
            },
            {
                name: 'Admin History',
                link: {
                    name: 'All Talk To My Data Invocations'
                },
                disable: !$store.getters.userRoles.isAqferAdmin && !$store.getters.userRoles.isAqferManager
            },
            {
                name: `${chat ? chat.resourceId : 'Chat History'}`,
                link: {
                    name: 'Talk To My Data Specific Invocation',
                    params: {
                        id: ` `,
                    }
                },
                closeTab: true,
                disable: true,
            }
        ]" pretitle="aqfer Data Transformation" title="Talk 2 My Data" @nav-close-clicked="closeClick">
        </nav-header>
        <div>
            <router-view v-on:setChat="setChat">
            </router-view>
        </div>
    </div>
</template>
<script>
import NavHeader from "../../components/NavHeader.vue";
export default {
    name: "Talk To My Data",
    components: { NavHeader },
    data() {
        return {
            chat: null
        }
    },
    methods: {
        setChat(chat) {
            this.chat = chat;
        },
        closeClick() {
            this.chat = null;
            this.$router.push({
                name: "All Talk To My Data Invocations",
            });
        },
    }
}
</script>
<style></style>